import ZField from './ZField.js';

const emailPattern = '^[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)$';

export default window.ZForms.registerClass('field.text', class ZTextField extends ZField {
  constructor() {
    super(...arguments);
    this.pattern = null;
    this.patternInvalidText = null;
    this.isBig = false;
    this.rows = null; // number
    this.minLen = null; // number
    this.maxLen = null; // number
  }

  _updateParamsFromRaw(rawData) {
    super._updateParamsFromRaw(rawData);
    if (rawData.subtype == 'email') {
      this.pattern = emailPattern;
      this.patternInvalidText = rawData.pattern_invalid_text == null ? 'Требуемый формат email: <ваша почта>@<домен>.<доменная зона>' : rawData.invalide_text;
      this.isBig = false;
    } else {
      this.pattern = rawData.pattern === undefined ? this.pattern : rawData.pattern;
      this.patternInvalidText = rawData.pattern_invalid_text === undefined ? this.patternInvalidText : rawData.pattern_invalid_text;
      this.rows = rawData.big_text_rows === undefined ? this.rows : rawData.big_text_rows;
      this.isBig = this.rows != null;
    }

    this.minLen = rawData.min_len === undefined && this.minLen != null ? this.minLen : (rawData.min_len == null ? 0 : Math.max(rawData.min_len, 0));
    this.maxLen = rawData.max_len === undefined && this.maxLen != null ? this.maxLen : (rawData.max_len == null ? Infinity : rawData.max_len);
    if (this.minLen > this.maxLen) this.maxLen = this.minLen;
  }

  _defaultValueValidator(newVal) {
    const ans = super._defaultValueValidator(newVal);
    if (ans != null) return ans;

    if (String(newVal).length < this.minLen) return `Требуется не менее ${this.minLen} символов!`;
    if (String(newVal).length > this.maxLen) return `Требуется не более ${this.maxLen} символов!`;

    if (this.pattern != null) {
      const matcher = new RegExp(this.pattern).test(newVal);
      if (!matcher) return this.patternInvalidText != null ? this.patternInvalidText : 'Неверный формат!';
    }
  }

  packResponseValue(val) {
    if (val == null) return null;

    return String(val);
  }
});

